<template>
  <zen-one 
  :showuserinfo="false" 
  title="Pentadbiran"
  :crumbs="crumbs"
  >
  <z-page
  title="Tadbir Menu"
  >
  <w-card bg-color="z-pale-blue" class="mt4" v-if="menu">
    <w-flex class="mt3">
      <div class="xs4">
          <h5 class="fw-semibold m0">
              Label :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ menu.label }} </div>
      </div>
      <div class="xs4">
          <h5 class="fw-semibold m0">
              Ikon :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ menu.icon }} </div>
      </div>
      <div class="xs4">
          <h5 class="fw-semibold m0">
              Route :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ menu.route }} </div>
      </div>
    </w-flex>

    <w-flex class="mt3 mb4">
        <div class="xs4">
          <h5 class="fw-semibold m0">
              Tarikh Cipta :
          </h5>
          <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(menu.created_at) }} </div>
      </div>
        <div class="xs4">
            <h5 class="fw-semibold m0">
                Tarikh Ubah Akhir :
            </h5>
            <div class="fw-normal my1 fs-1"> {{ $zutil.dateformat(menu.updated_at) }} </div>
        </div>
    </w-flex>

  </w-card>

  <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-light1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Sunting
    </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
      @validate="submit"
      @success="success"
    >
    <!-- <z-lookup 
      label="Modul"
      name="module"
      url="administration.modulelookup"
      :sort="false"
      :cache="false"
      
      v-model="form.module_id"
    /> -->
    <z-input label="Label" v-model="form.label" name="name" :validators="[validators.required]" />
    <!-- <w-flex justify-center align-center>
        <z-input label="Icon" v-model="form.icon" name="icon" class="box xs10" />
        <w-icon xl class="box xs1">
          {{ form.icon }}
        </w-icon>
      </w-flex>

      <w-flex class="mt2">
        <w-dropdown
          label="Pilih Icon"
          class="xs12"
        >
          <template #activator="{ on }">
            <w-button v-on="on" class="indigo-dark2--bg white--text" block>
              <w-icon class="mr1">fal fa-icons</w-icon> Pilih Icon
            </w-button>
          </template>

          <div class="pa2" style="max-height: 200px; overflow-y: auto;">
            <w-flex wrap>
              <w-button
                v-for="icon in iconList"
                :key="icon"
                small
                tile
                class="ma1 blue-dark2--bg"
                @click="form.icon = icon"
              >
                <w-icon>{{ icon }}</w-icon>
              </w-button>
            </w-flex>
          </div>
        </w-dropdown>
      </w-flex> -->

      <w-flex class="mb2" column>
           <label class="mb1">Pilih Icon : </label>

           
           <w-flex wrap style="max-height: 200px; overflow-y: auto;">
             <w-button 
               v-for="icon in filteredIcons" 
               :key="icon" 
               @click="form.icon = icon"
               :class="['m2', form.icon === icon ? 'blue-dark5--bg white--text' : 'blue-dark2--bg']"
               tile
               md
             >
               <w-icon :class="icon"></w-icon>
             </w-button>
           </w-flex>

           
           <div class="mt2">
             Icon Terpilih:
             <w-icon xl class="ml1">{{ form.icon }}</w-icon>
           </div>
         </w-flex>



    <!-- <template v-if="form.id == 0"> -->
    <!-- <z-input label="Route" v-model="form.route" name="route" :validators="[validators.required]" /> -->
   <!-- </template> -->
   <template v-if="form.id > 0">
        <z-input label="Route" v-model="form.route" name="route" disabled />
   </template>
   <template v-else>
        <z-input label="Route" v-model="form.route" name="route" :validators="[validators.required]" />
   </template>

    <z-input label="Susunan" v-model="form.sort" name="sort" :validators="[validators.required]" />

    </w-form>

    
    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()"
      >
        Simpan
      </w-button>
    </template>    
  </w-dialog>

  
  <z-table
    ref="tbluser"
    title="Senarai Kebenaran"
    :headers="table.headers"
    :items="table.items"
    :meta="table.meta"
    class="white--bg"
  >

    <template #button>
      <w-button 
      dark
      class="indigo-dark2--bg ml1" 
      @click="newrecord()"
      >
        <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
      </w-button>
    </template>
  
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <!-- <w-icon>fal fa-pencil</w-icon> -->
      Tindakan
      </template>
      <template v-else>
      {{ label }}
      </template>

    </template>

    <template #item-cell.icon="{ item, label, header, index }">
      <w-icon md class="mr1" >{{ item.icon }}</w-icon>
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="bs fs-2" bg-color="orange-light3" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini
        </w-button>
        &nbsp;  
        <w-button class="fs-2" bg-color="red-light1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
        </w-button>
        &nbsp;  
        <w-button
          bg-color="info-dark1"
          dark
          tile
          :route="$route('administration.menu.show',item.id)"
          class="be fs-2"
        >
          <w-icon xs class="mr2">fal fa-eye</w-icon> Papar
        </w-button>
      </w-flex>
    </template>

  </z-table>

  </z-page>
  </zen-one>
</template>

<script>
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    menu: [Array, Object],
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'administration.menu',
      reload: true,
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Pentadbiran', route: '/administration' },
        { label: 'Menu', route: '/administration/permission' }
      ],
      form: {
      id: 0,
      label: '',
      icon: '',
      route: '',
      menu_id: 0,
      module_id: 0,
      sort: 0,
    },
    search: {
      module_id: 0,
      keyword: '',
    },
    searchadvance: false,
    iconSearch: '',
    icons: [
      'fal fa-home',
      'fal fa-user',
      'fal fa-cog',
      'fal fa-envelope',
      'fal fa-bell',
      'fal fa-calendar',
      'fal fa-chart-bar',
      'fal fa-file',
      'fal fa-database',
      'fal fa-lock',
      'fal fa-unlock',
      'fal fa-search',
      'fal fa-filter',
      'fal fa-plus',
      'fal fa-minus',
      'fal fa-times',
      'fal fa-check',
      'fal fa-arrow-left',
      'fal fa-arrow-right',
      'fal fa-arrow-up',
      'fal fa-arrow-down',
      'fal fa-bars',
      'fal fa-list',
      'fal fa-edit',
      'fal fa-trash',
      'fal fa-save',
      'fal fa-print',
      'fal fa-download',
      'fal fa-upload',
      'fal fa-sync',
      'fal fa-key',
      'fal fa-globe',
      'fal fa-info-circle',
      'fal fa-question-circle',
      'fal fa-exclamation-circle',
      'fal fa-times-circle',
      'fal fa-check-circle',
      'fal fa-image',
      'fal fa-file-powerpoint',
      'fal fa-users',
      'fal fa-user-plus',
      'fal fa-book',
      'fal fa-bookmark',
      'fal fa-tachometer',
      'fal fa-wrench',
    ],
    ffilter: _.throttle(search => item  => {
      let keyword = search.keyword
      let allCols = ''
      Object.keys(item).forEach(i => allCols += item[i])
      let module = true
      let regex =  new RegExp(keyword, 'i').test(allCols) 
      if(search.module_id > 0) {
        module = item.module_id == search.module_id
      }
      return regex && module
    }, 100)
    }
  },
  computed: {
  filteredIcons() {
    if (!this.iconSearch) return this.icons
    return this.icons.filter(icon =>
      icon.toLowerCase().includes(this.iconSearch.toLowerCase())
    )
  }
},
  methods: {
    searchreset() {
          this.search.keyword = ''
          this.search.module_id = 0
        }
  },
  watch: {
    form: {
      handler: function () {
        if(this.menu) {
          this.form.menu_id = this.menu.id
        } else {
          this.form.menu_id = 0
        }
      },
      deep: true
    }
  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>